import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Product } from '../../../shared/models/shared.model';
import { ProductModuleState } from '../../models/product.model';
import * as actions from '../actions/product.actions';

export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>();

export const initialState = {
  products: null,
  customerProducts: null,
  isLoaded: false,
} as ProductModuleState;

const productReducer = createReducer(
  initialState,
  on(actions.clearProductState, (state) => ({
    ...state,
    isLoaded: false,
    products: null as Product[],
    customerProducts: null as Product[],
    selectedProduct: undefined as Product,
  })),
  on(actions.getProductsSuccess, (state, { products }) => ({
    ...state,
    products,
    isLoaded: true,
  })),
  on(actions.getCustomerProductsSuccess, (state, { customerProducts }) => ({
    ...state,
    customerProducts,
  })),
  on(actions.setSelectedProductSuccess, (state, { product }) => ({
    ...state,
    selectedProduct: product,
  })),
  on(actions.deleteProductSuccess, (state, { productId }) => ({
    ...state,
    selectedProduct: undefined as Product,
    products: [...state.products.filter((c) => c.id !== productId)],
  })),
  on(actions.deleteCustomerProductSuccess, (state, { productId }) => ({
    ...state,
    selectedProduct: undefined as Product,
    customerProducts: [...state.customerProducts.filter((c) => c.id !== productId)],
  })),
  on(actions.setSelectedCountrySuccess, (state, { id }) => ({
    ...state,
    selectedCountry: id,
  })),
);

export function reducer(state: ProductModuleState | undefined, action: Action) {
  return productReducer(state, action);
}
